import { render, staticRenderFns } from "./MallConfig.vue?vue&type=template&id=6c931d68&scoped=true"
import script from "./MallConfig.vue?vue&type=script&lang=js"
export * from "./MallConfig.vue?vue&type=script&lang=js"
import style0 from "./MallConfig.vue?vue&type=style&index=0&id=6c931d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c931d68",
  null
  
)

export default component.exports